export default "__VITE_ASSET__8e6e9864__"